<template>
  <owal-panel
    class="camera setup panel"
    title="Add Camera"
  >
    <div
      v-for="(camera, index) in cameras"
      :key="camera.id"
    >
      <new-camera
        :camera="camera"
        :index="index"
      />
    </div>
    <div class="button-row">
      <owal-button @click="addAnotherCameraForm">
        ➕ Add Camera
      </owal-button>
      <owal-button @click="sendNewDomain">
        🎉 Finished
      </owal-button>
    </div>
    <owal-modal-panel v-if="success">
      <div class="success">
        SUCCESS!
      </div>
      <owal-button @click="success=false">
        OK
      </owal-button>
    </owal-modal-panel>
  </owal-panel>
</template>
<script>
import * as OwalUI from '@/libraries/owal-ui'
import NewCamera from './NewCamera'
import { addNewDomainAndCameras } from '@/libraries/api/addDomain'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AddCameras',
  data () {
    return {
      manufacturer: undefined,
      streamPaths: {},
      success: false,
      localCameras: undefined,
    }
  },
  computed: {
    ...mapGetters({
      domainName: 'onboard/domainName',
      description: 'onboard/description',
      timezone: 'onboard/timezone',
      geoloc: 'onboard/geoloc',
      cameras: 'onboard/cameras',
      streams: 'onboard/streams',
    }),
  },
  methods: {
    ...mapMutations({
      addCamera: 'onboard/addCamera',
    }),
    addAnotherCameraForm () {
      this.addCamera({})
    },
    getCompleteDomainApiObject () {
      const newDomain = {
        fname: this.domainName,
        description: this.description,
        timezone: this.timezone,
        geoloc: this.geoloc,
        cameras: this.cameras,
        streams: this.streams,
      }
      return newDomain
    },
    sendNewDomain () {
      const domainToAdd = this.getCompleteDomainApiObject()
      addNewDomainAndCameras(domainToAdd).then(res => res.data).then(data => {
        if (data.ok) {
          console.log('Success')
          this.success = true
        } else {
          alert('Something went wrong while adding the camera.')
        }
      }).catch(error => {
        console.log('Error:', error)
      })
    },
  },
  components: {
    ...OwalUI,
    NewCamera,
  },
}
</script>
<style scoped>
.camera.setup.panel {
  display: flex;
  width: 70%;
  height: 95%;
  margin: auto;
  margin-bottom: 0;
  margin-top: 20px;
  padding: 0 !important;
}

.button-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.others {
  background-color: lightgray;
  border-radius: 15px;
}

.success {
  font-size: 48px;
  text-align: center;
  color: green;
}
</style>
